import React, { Component } from 'react';

// Graphql
import { graphql, compose } from 'react-apollo';
import gql from 'graphql-tag';

// React Final Form
import { Form, Field } from 'react-final-form';
import arrayMutators from 'final-form-arrays';
import { FieldArray } from 'react-final-form-arrays';

// Material UI Imports
import Paper from '@material-ui/core/Paper';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';

import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';


// Material Icons Imports
import IconContentSend from '@material-ui/icons/Send';
import IconContentReset from '@material-ui/icons/DeleteSweep';
import IconContentRemB from '@material-ui/icons/RemoveCircle';

import { DatePicker } from 'material-ui-pickers';

import Supervisors from "./innerComponents/Supervisors";

// Lodash
import _ from 'lodash';

// Assets imports
import '../styles/NewProject.css';
// Moment
import moment from 'moment';

// Import components
import CustomLoader from './innerComponents/CustomLoader';

const fieldStyle = {
  minHeight: "72px",
  width: "100%",
};

const buttonStyle = {
  marginRight: 12,
};

const paperStyle = {
  // General styles for paper
  width: "60%",
  margin: "0 auto",
  height: "auto",
};

class EditProject extends Component {

  state = {
    description: '',
    url: '',
    dataSource: [],
    refetched: false,
  }
  constructor(props) {
    super(props);
    this.state = {
      refetched: false
    }
  }

  handleChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };


  _regionsItems(items) {
    return items.map((item, id) => (
      <MenuItem
        value={item.id}
        key={item.id}

      >{item.name}</MenuItem>
    ));
  }

  _statusItems() {
    return ["Live", "Completed", "Cancelled"].map((statusName) => (
      <MenuItem
        value={statusName}
        key={statusName}

      >{statusName}</MenuItem>
    ));
  }

  _createLink = async values => {
    console.log(JSON.stringify(values, 0, 2))

    const name = values.projectName
    const number = values.projectNumber
    const siteAddress = values.siteAddress
    const siteName = values.siteName
    const location = values.location
    const regionId = values.regionId
    const dailyEntriesStatus = values.dailyEntriesStatus
    const status = values.status
    const startDate = moment(values.startDate).format('YYYY-MM-DDTHH:mm:ss.SSS')
    const endDate = moment(values.endDate).format('YYYY-MM-DDTHH:mm:ss.SSS')
    const supervisors = values.supervisors
    const initialSupervisors = values.initialSupervisors
    const deletedSupervisors = values.deletedSupervisors
    const currentProjectInvitations = values.currentProjectInvitations

    const newSupervisors = _.difference(supervisors, initialSupervisors)
    const removedSupervisors = _.difference(initialSupervisors, supervisors)
    const supervisorsToUpdate = _.difference(initialSupervisors, removedSupervisors)

    console.log("new")
    console.log(newSupervisors)
    console.log("rem")
    console.log(removedSupervisors)

    const reinsertedSups = _.intersection(newSupervisors, deletedSupervisors)
    const supsToAdd = _.difference(newSupervisors, reinsertedSups)


    let id = this.props.project_query.project.id

    await this.props.postMutation({
      variables: {
        id,
        name,
        number,
        siteAddress,
        siteName,
        location,
        regionId,
        startDate,
        endDate,
        dailyEntriesStatus,
        status
      }
    }).then(({ data }) => {
      alert("Project '" + data.updateProject.name + "' has been updated successfully and supervisors will be invited.", data)

      //sentence to create the project invitation

      if (removedSupervisors.length > 0) {
        _.filter(currentProjectInvitations, function (pi) {
          return _.includes(removedSupervisors, pi.user.id)
        })
          .map((pi) => this._editProjectInvitation(pi.id, true, pi.status))
      }

      if (supervisorsToUpdate.length > 0) {
        _.filter(currentProjectInvitations, function (pi) {
          return _.includes(supervisorsToUpdate, pi.user.id)
        })
          .map((pi) => this._editProjectInvitation(pi.id, false, pi.status))
      }

      if (supsToAdd.length > 0) {
        supsToAdd.map((supervisor) => this._createProjectInvitation(id, supervisor))
      }

      if (reinsertedSups.length > 0) {
        _.filter(currentProjectInvitations, (pi) => {
          return _.includes(reinsertedSups, pi.user.id)
        })
          .map((pi) => this._editProjectInvitation(pi.id, false, pi.status))
      }
      this.setState({ refetched: false })

      // this.props.history.push("/projects/list")
      // this.props.history.push(null, "/projects/list")
      this.props.history.replace({
        pathname: "/projects/list",
        state: { refetch: true, refetchDetail: true }
      });
    }).catch((error) => {
      alert("Project Could not be created")
      console.log('there was an error sending the mutation', error);
    });


  }

  _createProjectInvitation(currentCreatedProjectId, supervisorId) {
    this.props.projectInvitationMutation({
      variables: {
        currentCreatedProjectId,
        supervisorId
      }
    }).then(({ data }) => {
      // alert("The Supervisor \"" + data.createProjectInvitation.user.name + "\" has been notified, with the project invitation: " + data.createProjectInvitation.id, data)
    }).catch((error) => {
      // alert("Project Invitation Could not be created")
      console.log('there was an error sending the mutation', error);
    });
  }

  _editProjectInvitation(projectInvitationId, markAsDeleted, status) {
    this.props.updateProjectInvitationMark({
      variables: {
        projectInvitationId,
        markAsDeleted,
        status
      }
    }).then(({ data }) => {
      // alert("The Supervisor \"" + data.createProjectInvitation.user.name + "\" has been notified, with the project invitation: " + data.createProjectInvitation.id, data)
    }).catch((error) => {
      // alert("Project Invitation Could not be created")
      console.log('there was an error sending the mutation', error);
    });
  }


  componentDidMount() {
    this.props.project_query.refetch()
      .then(this.props.all_regions_query.refetch())
      .then(this.props.all_supervisors_query.refetch())
      .then(() => {
        this.setState({
          refetched: true
        })
      })
  }

  render() {
    const required = value => (value ? undefined : 'Required field');

    const TextFieldAdapter = ({ input, meta, ...rest }) => (
      <TextField
        {...input}
        {...rest}
        onChange={(event) => {
          input.onChange(event.target.value)
        }}
        error={meta.touched && meta.error !== undefined}
        helperText={meta.touched ? meta.error : ''}
      />
    );

    const DatePickerAdapter = ({ input, meta, ...rest }) => (
      <DatePicker
        {...input}
        {...rest}
        disableOpenOnEnter
        format="YYYY-MM-DD"
        invalidLabel=""
        onChange={(event) => {
          input.onChange(event.format('YYYY-MM-DDTHH:mm:ss.SSS'))
        }}
        error={meta.touched && meta.error !== undefined}
        helperText={meta.touched ? meta.error : ''}
      />
    );

    const SelectedFieldAdapter = ({ input, meta, ...rest }) => (
      <TextField
        {...input}
        {...rest}
        select
        onChange={(event) => input.onChange(event.target.value)}
        error={meta.touched && meta.error !== undefined}
        helperText={meta.touched ? meta.error : ''}
      />
    );

    // Check if the query response is being loaded
    if (this.props.all_regions_query && this.props.all_regions_query.loading) {
      return <CustomLoader label={'Loading Regions'}/>
    }

    // Check if there were errrors
    if (this.props.all_regions_query && this.props.all_regions_query.error) {
      return <div> Regions Could not be loaded </div>
    }


    // Check if the query response is being loaded
    if (this.props.all_supervisors_query && this.props.all_supervisors_query.loading) {
      return <CustomLoader label={'Loading Supervisor'}/>
    }

    // Check if there were errrors
    if (this.props.all_supervisors_query && this.props.all_supervisors_query.error) {
      return <div> Supervisor Could not be loaded </div>
    }


    // Check if the query response is being loaded
    if (this.props.project_query && this.props.project_query.loading) {
      return <CustomLoader label={'Loading Project'}/>
    }

    // Check if there were errrors
    if (this.props.project_query && this.props.project_query.error) {
      return <div> Project Could not be loaded </div>
    }

    if (!this.state.refetched) {
      return <CustomLoader label={'Loading'}/>
    }

    else {
      const dailyEntriesStatus = this.props.project_query.project.dailyEntriesStatus
      const mandatoryQuestionsMustBeCompleted = (value) => (((dailyEntriesStatus == "Missing") && (value == "Completed")) ? "Mandatory questions must be completed" : undefined);

      // Get the data to render it

      const all_regions = this.props.all_regions_query.regions;

      const current_project = this.props.project_query.project


      const all_supervisors = this.props.all_supervisors_query.users;

      const current_project_invitations = current_project.projectInvitations

      const active_project_invitations = _.filter(current_project_invitations, (pi) => {
        return !pi.markAsDeleted
      })
      const deleted_supervisors = _.difference(current_project_invitations, active_project_invitations).map(pi => pi.user.id)

      const current_pis = active_project_invitations.map(project_invitation => {
        return project_invitation.user.id
      })


      const selected_sups = active_project_invitations.map(project_invitation => {
        return project_invitation.user
      })
      const selected_sups_chips = selected_sups.map(pi => ({
        value: pi.id,
        label: [pi.fullName, pi.email],
      }))

      const initial_supervisors = selected_sups.map(sup => sup.id)

      const suggestions = all_supervisors.map(supervisor => ({
        value: supervisor.id,
        label: [supervisor.fullName, supervisor.email],
      }));

      return (
        <Paper style={paperStyle} elevation={1}>
          <div>
            <Form
              onSubmit={this._createLink}
              mutators={{
                ...arrayMutators
              }}
              initialValues={{
                projectName: current_project.name,
                projectNumber: current_project.number,
                siteAddress: current_project.siteAddress,
                siteName: current_project.siteName,
                location: current_project.location,
                regionId: current_project.region.id,
                startDate: current_project.startDate,
                endDate: current_project.endDate,
                dailyEntriesStatus: current_project.dailyEntriesStatus,
                status: current_project.status,
                supervisors: current_pis,
                initialSupervisors: initial_supervisors,
                deletedSupervisors: deleted_supervisors,
                currentProjectInvitations: current_project_invitations
              }}
              render={({ handleSubmit, mutators: { push, pop, forEach }, reset, submitting, pristine, values, supervisors }) => (

                <form onSubmit={handleSubmit}>
                  <div className="NewProject-header">
                    <div className="NewProject-title">
                      <span>{current_project.name}</span>
                    </div>
                    <div className="NewProject-actions">
                      <Button
                        color="primary"
                        onClick={this.props.history.goBack}
                      ><IconContentRemB style={{ marginRight: 8 }} /> Cancel</Button>
                    </div>
                  </div>
                  <div className="NewProject-content">

                    <Typography variant='h6' style={{ marginBottom: 16 + 'px' }}>Basic Information</Typography>
                    <div>
                      <Field
                        name="projectName"
                        validate={required}
                        component={TextFieldAdapter}
                        placeholder="Type the project name"
                        label="Project Name"
                        style={fieldStyle}
                      />
                    </div>
                    <div>
                      <Field
                        name="projectNumber"
                        validate={required}
                        component={TextFieldAdapter}
                        placeholder="Type the projecy number"
                        label="Project Number"
                        style={fieldStyle}
                      />
                    </div>
                    <div>
                      <Field
                        name="status"
                        validate={mandatoryQuestionsMustBeCompleted}
                        component={SelectedFieldAdapter}
                        label="Status"
                        style={fieldStyle}
                      >
                        {this._statusItems()}
                      </Field>
                    </div>
                    <div>
                      <Field
                        name="siteAddress"
                        validate={required}
                        component={TextFieldAdapter}
                        placeholder="Type the site Address"
                        label="Site Address"
                        style={fieldStyle}
                      />
                    </div>
                    <div>
                      <Field
                        name="siteName"
                        validate={required}
                        component={TextFieldAdapter}
                        placeholder="Type the site name"
                        label="Site Name"
                        style={fieldStyle}
                      />
                    </div>
                    <div>
                      <Field
                        name="location"
                        validate={required}
                        component={TextFieldAdapter}
                        placeholder="Type the location"
                        label="Location"
                        style={fieldStyle}
                      />
                    </div>
                    <div>
                      <Field
                        name="regionId"
                        validate={required}
                        component={SelectedFieldAdapter}
                        label="Region Id"
                        style={fieldStyle}
                      >
                        {this._regionsItems(all_regions)}
                      </Field>
                    </div>


                    <Typography variant='h6' style={{ marginBottom: 16 + 'px' }}>Project Dates</Typography>

                    <div>
                      <Field
                        name="startDate"
                        validate={required}
                        component={DatePickerAdapter}
                        label="Start Date"
                        style={fieldStyle}
                      //   val={current_project.startDate}
                      />
                    </div>
                    <div>
                      <Field
                        name="endDate"
                        validate={required}
                        component={DatePickerAdapter}
                        label="End Date"
                        style={fieldStyle}
                      //   val={current_project.endDate}
                      />
                    </div>


                    <Typography variant='subtitle1' style={{ marginBottom: 8 + 'px' }}>Supervisors</Typography>
                    <div>
                      <FieldArray name="supervisors">
                        {({ fields }) =>

                          <Field
                            name="supervisors"
                            options={suggestions}
                            component={Supervisors}
                            placeholder="Type to search and add a supervisor"
                            validate={required}
                            defaultValue={selected_sups_chips}
                            onChange={(event, value) => {
                              if (value['action'] === 'select-option') {
                                push('supervisors', value['option']['value'])
                              }
                              else if (value['action'] === 'remove-value') {
                                fields.forEach((name, index) => {
                                  if (fields['value'][index] === value['removedValue']['value']) {
                                    fields.remove(index)
                                  }
                                })
                              }

                            }
                            }
                          />
                        }
                      </FieldArray>
                    </div>
                  </div>
                  <div className="NewProject-detailFooter">
                    <div className="buttons">
                      <Button variant="contained"
                        type="submit"
                        color="primary"
                        style={buttonStyle}
                        disabled={submitting}
                      ><IconContentSend style={{ marginRight: 8 }} />Submit</Button>

                      <Button variant="contained"
                        type="button"
                        color="secondary"
                        style={buttonStyle}
                        onClick={reset}
                        disabled={submitting}
                      ><IconContentReset style={{ marginRight: 8 }} /> Reset</Button>
                    </div>
                  </div>
                </form>

              )}
            />
          </div>
        </Paper>

      )
    };
  }
}

const submitProject = gql`
  mutation updateProject($id:ID! $name: String!, $number: String!, $siteAddress: String!, $siteName: String!, $location: String!, $regionId: ID!, $startDate: Date!, $endDate: Date!, $dailyEntriesStatus: String!, $status: String!) {
    updateProject(projectId: $id,input: {name: $name, number: $number, siteAddress:  $siteAddress, siteName: $siteName, location: $location, regionId: $regionId, startDate: $startDate, endDate: $endDate, dailyEntriesStatus: $dailyEntriesStatus, status: $status}) {
      id
      name
    }
}
`;

const submitProjectInvitation = gql`
  mutation createProjectInvitation($currentCreatedProjectId: ID!, $supervisorId: ID!){
    createProjectInvitation(input: {projectId: $currentCreatedProjectId, userId: $supervisorId, status: "SEND"}){
      id
      user{
        name
      }
    }
  }
`;

const updateProjectInvitationMark = gql`
  mutation editProjectInvitation2($projectInvitationId: ID!, $markAsDeleted: Boolean!, $status: String!){
    updateProjectInvitation(projectInvitationId: $projectInvitationId, input: {markAsDeleted: $markAsDeleted, status: $status}){
      id
    }
  }
`;

const ALL_REGIONS_QUERY = gql`
  query {
    regions {
      id
      name
    }

  }
`;

const ALL_SUPERVISORS_QUERY = gql`
  query {
    users(filters: [{field: "role_eq", operand: "Supervisor" },{field:"active_eq", operand:"true"}]){
      id
      fullName
      role
      email
    }
  }
`;

const PROJECTS_QUERY = gql`
  query project_query($selectedId: ID!){
    project(id: $selectedId) {
      id
      endDate
  		startDate
  		siteAddress
  		siteName
  		location
  		name
  		number
      status
      dailyEntriesStatus
      region{
          id
        name
      }
      projectInvitations{
          id
          status
      markAsDeleted
      user{
        id
        fullName
      role
      email
      }
    }
    }
  }
`;

// const ProfileWithData = graphql(ALL_REGIONS_QUERY, { name: 'all_regions_query' })(NewProjectForm);
export default compose(
  graphql(submitProject, { name: 'postMutation' }),
  graphql(submitProjectInvitation, { name: 'projectInvitationMutation' }),
  graphql(updateProjectInvitationMark, {
    name: 'updateProjectInvitationMark',
    options: {
      refetchQueries: ["all_users_query", "all_projects_query"]
    }
  }),
  graphql(ALL_REGIONS_QUERY, { name: 'all_regions_query' }),
  graphql(ALL_SUPERVISORS_QUERY, { name: 'all_supervisors_query' }),
  graphql(PROJECTS_QUERY, {
    name: 'project_query',
    options: (props) => ({ variables: { selectedId: props.match.params.id } })
  })
)(EditProject);


// WEBPACK FOOTER //
// src/components/EditProject.js